import { getHTMLFromFragment } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';

/** Retains paragraph/heading alignment as HTML within Markdown using the editor's existing schema. */
export function createEmailStarterKit(getEditor) {
  return StarterKit.extend({
    /** Adds alignment-aware serialization to the standard paragraph and heading nodes. */
    addExtensions() {
      return this.parent().map(extension => {
        if (!['paragraph', 'heading'].includes(extension.name)) return extension;

        return extension.extend({
          /** Uses ordinary Markdown for unaligned text and safe HTML for aligned blocks. */
          renderMarkdown(node, helpers, context) {
            if (!node.attrs?.textAlign) return this.parent(node, helpers, context);

            const { schema } = getEditor();
            const document = schema.nodeFromJSON({
              type: 'doc',
              content: [node]
            });

            return getHTMLFromFragment(document.content, schema);
          }
        });
      });
    }
  });
}
